const routers = [
  {
  path: "/family",
  name: 'family',
  component: resolve =>
    require(["@/components/family/index/layout"], resolve),
  children: [
    {
      path: "/family",
      name: "familyIndex",
      component: resolve =>
        require(["@/pages/family/v1/home/index"], resolve)
    },
    {
      path: "/family/message",
      component: resolve =>
        require(["@/pages/family/v1/message/Message"], resolve),
      meta: { title: "消息" }
    },
    {
      path: "/family/menu",
      component: resolve =>
        require(["@/pages/family/v1/menu/index"], resolve),
      meta: { title: "菜单" }
    },
    {
      path: "/family/mine",
      component: resolve =>
        require(["@/pages/family/v1/mine/index"], resolve),
      meta: { title: "我的" }
    },
  ]
},
{
  path: '/family/elderly/plan',
  component: resolve => require(["@/pages/family/v1/home/children/components/layout"], resolve),
  children: [
    {
      path: '/family/elderly/plan',
      component: resolve => require(["@/pages/family/v1/home/children/plan"], resolve),
      meta: { title: "照护计划" }
    },
    {
      path: '/family/elderly/patrol',
      component: resolve => require(["@/pages/family/v1/home/children/patrol"], resolve),
      meta: { title: "巡视记录" }
    },
    {
      path: '/family/elderly/score',
      component: resolve => require(["@/pages/family/v1/home/children/score"], resolve),
      meta: { title: "暖心币" }
    },
    {
      path: '/family/elderly/nursing-item',
      component: resolve => require(["@/pages/family/v1/home/children/nursingItem"], resolve),
      meta: { title: "护理服务" }
    },
    {
      path: '/family/elderly/drug',
      component: resolve => require(["@/pages/family/v1/home/children/dayDrug"], resolve),
      meta: { title: "今日用药" }
    },
    {
      path: '/family/elderly/nursing',
      component: resolve => require(["@/pages/family/v1/home/children/nursing"], resolve),
      meta: { title: "今日用药" }
    },
  ]
},
// {
//   path: '/family/elderly/plan',
//   component: resolve => require(["@/pages/family/v1/home/children/plan"], resolve),
//   meta: { title: "照护计划" }
// },

//消息详情
{
  path: "/family/message/detail",
  component: resolve =>
    require(["@/pages/family/v1/message/MessageDetail"], resolve),
  meta: { title: "消息详情" }
},
//菜单子页面
{
  path: "/family/account",
  component: resolve =>
    require(["@/pages/family/v1/menu/account/index"], resolve),
  meta: { title: "账户管理" }
},
{
  path: "/family/bill",
  component: resolve =>
    require(["@/pages/family/v1/menu/bill/index"], resolve),
  meta: { title: "费用账单" }
},
{
  path: "/family/drug",
  component: resolve =>
    require(["@/pages/family/v1/menu/drug/components/layout"], resolve),
  children: [
    {
      path: "/family/drug",
      component: resolve =>
        require(["@/pages/family/v1/menu/drug/Drug"], resolve),
      meta: { title: "药品管理" },
    },
    {
      path: "/family/delivery/log",
      component: resolve =>
        require(["@/pages/family/v1/menu/drug/DeliveryHistory"], resolve),
      meta: { title: "送药记录" }
    },
  ]
  },
  {
    path: "/family/visit",
    component: resolve =>
      require(["@/pages/family/v1/Menu/visit/index"], resolve),
    meta: { title: "探访请假" }
  },
  {
    path: "/family/illness",
    component: resolve =>
      require(["@/pages/family/v1/menu/illness/index"], resolve),
    meta: { title: "长者病历" }
  },
  {
    path: "/family/score",
    component: resolve =>
      require(["@/pages/family/v1/menu/score/index"], resolve),
    meta: { title: "暖心币" }
  },
  {
    path: "/family/daydrug",
    component: resolve =>
      require(["@/pages/family/v1/menu/daydrug/index"], resolve),
    meta: { title: "每日用药" }
  },
  {
    path: "/family/shift",
    component: resolve =>
      require(["@/pages/family/v1/menu/shift/index"], resolve),
    meta: { title: "交接班" }
  },
  {
    path: "/family/photo",
    component: resolve =>
      require(["@/pages/family/v1/menu/photo/index"], resolve),
    meta: { title: "长者靓照" }
  },
  {
    path: "/family/analysis",
    component: resolve =>
      require(["@/pages/family/v1/menu/analysis/index"], resolve),
    meta: { title: "健康分析" },
  },
  { 
    path: "/family/chart",
    component: resolve =>
      require(["@/pages/family/v1/menu/analysis/chart/chart"], resolve),
    meta: { title: "数据分析图" }
  },
  {
    path: "/family/serve",
    component: resolve =>
      require(["@/pages/family/v1/menu/serve/index"],resolve),
    meta: { title: "护理服务" }
  },
  { 
    path: "/family/food",
    component: resolve =>
      require(["@/pages/family/v1/menu/food/index"], resolve),
    meta: { title: "每日食谱" }
  },
  {
    path: "/family/drug/plan",
    component: resolve =>
      require([
        "@/pages/family/v1/menu/drug/drugChildren/DrugPlan"
      ], resolve),
    name: "drugPlan",
    meta: { title: "用药计划" }
  },
  {
    path: "/family/drug/record",
    component: resolve =>
      require([
        "@/pages/family/v1/menu/drug/drugChildren/DrugRecord"
      ], resolve),
    name: "drugRecord",
    meta: { title: "用药记录" }
  },
  {
    path: "/family/delivery/record",
    component: resolve =>
      require([
        "@/pages/family/v1/menu/drug/drugChildren/DrugDeliveryRecord"
      ], resolve),
    name: "deliveryRecord",
    meta: { title: "送药记录" }
  },
  {
    path: "/family/nursing-target",
    component: resolve =>
      require([
        "@/pages/family/v1/menu/nursing-target/index"
      ], resolve),
    name: "nursingTarget",
    meta: { title: "照护目标" }
  },
  {
    path: "/family/satisfaction-detail/:number",
    component: resolve =>
      require([
        "@/pages/family/satisfaction/detail"
      ], resolve),
    name: "satisfactionDetail",
    meta: { title: "问卷详情" }
  }
]

export default routers


// WEBPACK FOOTER //
// ./src/router/family.js